package tta.destinigo.talktoastro.feature_call_consultation.persentation.call_bottom_sheet_info

import co.touchlab.kermit.Logger
import com.arkivanov.decompose.ComponentContext
import com.arkivanov.essenty.lifecycle.doOnDestroy
import com.arkivanov.essenty.lifecycle.doOnStart
import tta.destinigo.talktoastro.feature_call_consultation.domain.CallConsultationInfoRepo
import tta.destinigo.talktoastro.feature_call_consultation.data.request.RequestCallDuration
import tta.destinigo.talktoastro.feature_call_consultation.data.response.CallDurationData
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.cancel
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject
import tta.destinigo.talktoastro.feature_wallet.data.api.WalletRechargeApi
import tta.destinigo.talktoastro.shared.data.CommonExpertInfo
import tta.destinigo.talktoastro.shared.data.RechargeData
import tta.destinigo.talktoastro.shared.remote.Resources

class CallConsultationComponent(
    context: ComponentContext,
    private val _isEmergency:Boolean,
    val expertInfo: CommonExpertInfo,
    private val onClose: () -> Unit,
    private val onNavigateRechargeCheckOut: (RechargeData?) -> Unit,
    private val onLetsConnectButtonClick: () -> Unit,
    private val onVoIpCallStart: (String) -> Unit,
) : ComponentContext by context, KoinComponent {

    companion object {
        private const val FREE_CALL_TEXT = "Free Call"
    }

    private val emergency get() = _isEmergency
    private val coroutineScope = CoroutineScope(SupervisorJob() + Dispatchers.Main)
    private val api: CallConsultationInfoRepo by inject()
    private val _state =
        MutableStateFlow<CallInfoBottomSheetState>(CallInfoBottomSheetState.Loading(false))
    val state get() = _state.asStateFlow()


    fun onClosePage() = onClose.invoke()
    fun onVoIpCallStart(callDuration: String) = onVoIpCallStart.invoke(callDuration)

    fun event(event: CallConsultationEvent) {
        when (event) {

            is CallConsultationEvent.OnNavigateRechargeCheckOut -> onNavigateRechargeCheckOut.invoke(
                event.rechargeData
            )
        }
    }

    fun onClickLetsConnectButton() = onLetsConnectButtonClick.invoke()

    init {
        lifecycle.doOnStart {
            coroutineScope.launch {
                getConsultationInfo()
            }
        }
        lifecycle.doOnDestroy {
            coroutineScope.cancel()
        }
    }

    private fun onError(msg: String) = coroutineScope.launch {
        _state.emit(CallInfoBottomSheetState.Error(msg))
    }

    private fun onSuccess(data:CallDurationData?) = coroutineScope.launch{
        if(data ==null){
            onError("Something went wrong")
            return@launch
        }

        if (data.activeStatus.equals("Busy", true)) {
            onError("Sorry, our expert is currently occupied. Please try again later.")
            return@launch
        }

        if (data.type.equals(FREE_CALL_TEXT, true) && (data.balanceAsInt  ?: 0) <= (data.minimumBalanceAsInt ?: 0)
        ) {
            _state.emit(CallInfoBottomSheetState.FreeCallLowBalance(data))
            return@launch
        }

        if (data.minimumBalance != null && data.type.equals(FREE_CALL_TEXT, true).not()) {
            // Check if minimumBalanceAsInt is not null and type is not FREE_CHAT_TEXT
            // Low Balance
            if (data.balance != null && data.balance!!.toFloat() < data.minimumBalance.toFloat()) {
                // Check if balanceAsInt is not null and is less than minimumBalanceAsInt
                getRechargePlans(data)
                return@launch
            }
        }

        _state.emit(CallInfoBottomSheetState.CallInfoSuccess(data))
    }


    private suspend fun getConsultationInfo() {
        val request = RequestCallDuration(
            expertInfo.expertId.toString()
        )

        api.getCallConsultationInfo(request, isEmergency = emergency).collect {
            when (it) {
                is Resources.Error<*> -> {
                    Logger.d("Error state in getConsultationInfo ${it.msg} ")
                    onError(it.msg ?: "Unexpected Error")
                }

                is Resources.Loading<*> -> _state.emit(CallInfoBottomSheetState.Loading(it.isLoading))
                is Resources.Success<*> -> onSuccess(data = it.data)
            }
        }
    }

    private suspend fun onRechargeListLoaded(data: CallDurationData, list: List<RechargeData>) {
        _state.emit(CallInfoBottomSheetState.NormalCallLowBalance(data, list))
    }

    private suspend fun getRechargePlans(callDurationData: CallDurationData) {
        val rechargePackState = WalletRechargeApi().requestRechargePlanList().data?.data
        if (rechargePackState.isNullOrEmpty()) {
            onError("Something Went Wrong While Loading")
            return
        }

        onRechargeListLoaded(callDurationData, rechargePackState)
    }
}